import {Transaction} from 'core/entities';

class SolutionTransaction {
	constructor(debtor, amount, creditor) {
		this.debtor = debtor;
		this.amount = amount;
		this.creditor = creditor;
	}

	pay() {
		const book = this.book();
		return book.addChildren(new Transaction(book, {
			creditor_id: this.debtor.id,
			debtor_id: this.creditor.id,
			amount: this.amount,
			origin_entity: book.userBooker().key.data,
			origin_event: 'payback'
		}));
	}

	book() {
		return this.debtor.parent;
	}

	key() {
		return `${this.debtor.key.toString()}${this.creditor.key.toString()}`;
	}
}

function compareBalance(b1, b2) {
	return b1.value - b2.value;
}

export default function solveDebts(balance, bookerProvider) {
	const transactions = [];

	if (balance) {
		// Separator creditors from debtors
		const creditors = [], debtors = [];
		for (let bookerBalance of balance) {
			let value = bookerBalance.value[1];
			if (Math.abs(value) > 0.01) {
				(bookerBalance.value[1] < -0.01 ? debtors : creditors).push({id: bookerBalance.id, value: bookerBalance.value[1]});
			}
		}

		// Compute transactions
		if (debtors.length > 0) {
			debtors.sort(compareBalance);
			creditors.sort(compareBalance);

			let indexDebtor = 0, indexCreditor, debtor, creditor, delta, amount;
			while (true) {
				debtor = debtors[indexDebtor];
				indexCreditor = 0;
				for (creditor of creditors) {
					delta = creditor.value + debtor.value;
					if (delta < 0) {
						break;
					}
					indexCreditor += 1;
				}

				if (indexCreditor > 0) {
					indexCreditor -= 1;
					creditor = creditors[indexCreditor];
					delta = creditor.value + debtor.value;
				}

				if (delta < 0) {
					amount = creditor.value;
					debtor.value += amount;
					creditor.value = 0;
				} else {
					amount = -debtor.value;
					debtor.value = 0;
					creditor.value -= amount;
				}

				transactions.push(new SolutionTransaction(
					bookerProvider.getBooker(debtor.id),
					amount,
					bookerProvider.getBooker(creditor.id)));

				if (debtor.value > -0.001) {
					debtors.splice(indexDebtor, 1);
				} else {
					indexDebtor += 1;
				}
				if (creditor.value < 0.001) {
					creditors.splice(indexCreditor, 1);
					creditor = null;
				} else {
					creditors.sort(compareBalance);
				}

				if (indexDebtor >= debtors.length - 1) {
					if (debtors.length === 0 || creditors.length === 0) {
						break;
					}
					indexDebtor = 0;
				}
			}
		}

		// Sort transactions by debtor name
		transactions.sort((t1, t2) => t1.debtor.name.localeCompare(t2.debtor.name));
	}

	return transactions;
}


// WEBPACK FOOTER //
// ./src/core/debts-solver.js